import { InteracBulkPayoutTransactionResponse } from 'vopay';
import { useEffect, FC, useState } from 'react';
import InteracBulkPayoutTransactionInfo from './InteracBulkPayoutTransactionInfo';
import useFetchInteracBulkPayoutTransaction from '@/hooks/useApi/useFetchInteracBulkPayoutTransaction';

type TransactionProps = {
  TransactionID: string;
  Notes?: string;
  isParent?: boolean;
  jwt: string;
  ELinxRequestID?: string;
};

const InteracBulkPayoutTransactionContainer: FC<TransactionProps> = ({
  TransactionID,
  Notes,
  isParent = false,
  jwt,
  ELinxRequestID = '',
}) => {
  const [InteracBulkPayout, getInteracBulkPayoutTransaction] = useFetchInteracBulkPayoutTransaction({ bearer: jwt });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<InteracBulkPayoutTransactionResponse>();

  useEffect(() => {
    getInteracBulkPayoutTransaction(TransactionID);
  }, [currentTransactionId]);

  useEffect(() => {
    if (InteracBulkPayout) {
      setTransaction(InteracBulkPayout);
    }
  }, [InteracBulkPayout]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return (
    <div>
      {transaction && (
        <InteracBulkPayoutTransactionInfo transaction={transaction} Notes={Notes || ''} isParent={isParent} jwt={jwt} ELinxRequestID={ELinxRequestID} />
      )}
    </div>
  );
};

export default InteracBulkPayoutTransactionContainer;
